<template>
  <div class="content-area">
    <HeroBar>
      {{ title }}
      <b-button
        v-if="checkPermission('update_settings')"
        slot="right"
        icon-left="content-save"
        type="is-link"
        :class="{ 'is-loading': loading }"
        @click="save"
      >
        {{ $t('save') }}
      </b-button>
    </HeroBar>
    <section class="section is-main-section">
      <CardComponent :title="title">
        <b-loading :active="loading" :is-full-page="false" />
        <GeneralSettings
          v-if="group === 'general'"
          ref="generalSettings"
          @loading="(state) => loading = state"
        />
        <TransferSettings
          v-else-if="group === 'transfer'"
          ref="transferSettings"
          @loading="(state) => loading = state"
        />
      </CardComponent>
    </section>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'
import GeneralSettings from '@/components/Settings/GeneralSettings'
import TransferSettings from '@/components/Settings/TransferSettings'

export default {
  title: 'Ayarlar',
  components: {
    HeroBar,
    CardComponent,
    GeneralSettings,
    TransferSettings,
  },
  props: {
    group: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    title () {
      return {
        general: 'Genel Ayarlar',
        transfer: 'Taşıt Görev Ayarları',
      }[this.group] || 'Ayarlar'
    },
  },
  methods: {
    async save () {
      if (!this.checkPermission('update_settings')) {
        return
      }

      this.loading = true

      const ref = {
        general: 'generalSettings',
        transfer: 'transferSettings',
      }[this.group] ?? ''

      try {
        await this.$refs[ref].save()

        this.$buefy.toast.open({
          message: 'Ayarlar kaydedildi.',
          type: 'is-success',
          queue: false,
        })
      } catch (err) {
        this.$buefy.toast.open({
          message: 'Kaydedilirken bir hata oluştu.',
          type: 'is-danger',
          queue: false,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
